<template>

  <div class="card-product cart__content catalog-items" :class="{ 'nostock': !product.availability }">

    <span class="card-product__stock" v-if="!product.availability">
      <img src="/img/svg/out-stock.svg" alt="" style="width: 16px;height: 16px;margin: 0">
      нет в наличии
    </span>
    <span class="card-product__suitability" v-if="product.ean && product.ean.includes('srok')">Короткий срок годности</span>
    <span class="card-product__discount-t" v-if="product.price.without_discount && !product.ean.includes('srok')">{{ product.price.discount_percentage|round }}% скидка от производителя</span>


    <a :href="product.url">
      <swiper :pagination="true" :navigation="true" :loop="true" class="my-swiper" :modules="modules">
        <swiper-slide v-for="(img, index) in product.images" :key="index">
          <img :src="img" :alt="`Изображение ${index + 1}`" />
        </swiper-slide>
      </swiper>
<!--      <img :src="product.image" :alt="product.name">-->
    </a>

    <div class="card-product__rating">
      <img src="/img/svg/rating-star.svg" alt="" style="width: 17px;height: 21px;margin:0">
      {{ product.average_rating }}
      <button
          class="cart__favorite favorite-toggle"
          :class="{ 'activeFavirite': product.is_favorite }"
          :data-id="product.id"
          :data-url="`/favorite/toggle/${product.id}`"
          :aria-pressed="product.is_favorite"
      >
        <i class="fa-regular fa-heart"></i>
      </button>
    </div>
    <div class="card-product__info">
      <div class="card-product__top">
        <h3><a :href="product.url">{{ product.name }}</a></h3>
      </div>
      <div class="card-product__bottom">
        <div class="card-product__price-block">
          <div class="card-product__price">
            <span v-if="product.price && product.price.price">{{ product.price.price }} руб</span>
            <span v-else>Цена не указана</span>
            <span v-if="product.price && product.price.without_discount">{{ product.price.without_discount }} руб</span>
          </div>
          <div class="card-product__ball" v-if="product.balls>0">
            <span>+{{ product.balls }} балла</span>
            <img src="/img/svg/question-mark.svg" alt="" style="width: 14px;height: 14px;margin:0">
            <div class="card-product__hint" v-if="product.balls>0">+{{ product.balls }} баллов за покупку товара</div>
          </div>
        </div>

        <p v-if="!isAuth && !product.price.without_discount && !product.ean.includes('srok')">Скидка 15%, при регистрации</p>

        <button v-if="product.quantity > 0"
                class="card-product__basket"
                :data-product_id="product.id"
                @click="addToCart(product.id)">
          В корзину
        </button>

        <button v-else
                class="card-product__basket"
                :data-product-id="product.id"
                data-bs-toggle="modal"
                data-bs-target="#stockRequestModal">
          Узнать о поступлении
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';              // ← Добавить
import 'swiper/css/pagination';   // ← Добавить
import 'swiper/css/navigation';
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    isAuth: { type: Boolean, required: false },
    isOutlet: {
      type: Boolean,
      default: false  // ← по умолчанию false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Pagination, Navigation], // ← Добавить модули в data
    };
  },
  methods: {
    favoriteToggleUrl(productId) {
      return `/favorite/toggle/${productId}`;
    },
    addToCart(productId) {
      this.$emit('add-to-cart', productId);
    },
  },
};
</script>
<style scoped>

</style>